// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component__hjbjC","item":"index_item__3BHqk"};